// thx arco
export function isDayjs(time) {
    // dayjs.isDayjs in practical application scenarios, such as multiple versions of dayjs may fail
    return (isObject(time) &&
        "$y" in time &&
        "$M" in time &&
        "$D" in time &&
        "$d" in time &&
        "$H" in time &&
        "$m" in time &&
        "$s" in time);
}
export function isArray(obj) {
    return Object.prototype.toString.call(obj) === "[object Array]";
}
export function isObject(obj) {
    return Object.prototype.toString.call(obj) === "[object Object]";
}
export function isEmptyObject(obj) {
    return isObject(obj) && Object.keys(obj).length === 0;
}
export function isPromise(obj) {
    return Object.prototype.toString.call(obj) === "[object Promise]";
}
export function isString(obj) {
    return Object.prototype.toString.call(obj) === "[object String]";
}
export function isNumber(obj) {
    return (Object.prototype.toString.call(obj) === "[object Number]" && obj === obj);
}
export function isFile(obj) {
    return Object.prototype.toString.call(obj) === "[object File]";
}
export function isFunction(value) {
    return typeof value === "function";
}
export function isUndefined(obj) {
    return obj === undefined;
}
export function isNull(obj) {
    return obj === null;
}
export function isNullOrUndefined(obj) {
    return obj === null || obj === undefined;
}
// thx arco
export const isServerRendering = (function () {
    try {
        return !(typeof window !== "undefined" && document !== undefined);
    }
    catch (e) {
        return true;
    }
})();
/** merge multiple children to a string node */
export const isSingleNode = (child) => {
    return isString(child) || isNumber(child);
};
//# sourceMappingURL=is.js.map